import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { Link } from 'react-router-dom';

export default function About() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://caoliuhome.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      {
        '@type': 'Organization',
        name: '草榴回家的路',
        url: 'https://caoliuhome.com/',
        description: '草榴回家的路官方导航站，致力于为草榴社区用户提供最新、最全的访问地址与使用指南。',
      },
      {
        '@type': 'AboutPage',
        name: '关于我们 - 草榴回家的路',
        description: '了解草榴回家的路的品牌故事、用户口碑与联系方式',
        url: 'https://caoliuhome.com/about',
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4 flex-wrap" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-600 transition-colors">
                  首页
                </Link>
                <i className="ri-arrow-right-s-line text-xs" />
                <span className="text-foreground-900">关于我们</span>
              </nav>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">关于我们</h1>
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-4xl mx-auto space-y-14">
              <section>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">品牌介绍</h2>
                <div className="prose prose-lg max-w-none">
                  <p className="text-foreground-600 leading-relaxed">
                    草榴回家的路成立于2020年，是草榴社区用户自发创建和维护的官方导航站点。我们的使命是帮助每一位草榴社区用户快速、安全地找到最新可用地址，让"回家的路"不再遥远。
                  </p>
                  <p className="text-foreground-600 leading-relaxed mt-4">
                    经过多年的发展，草榴回家的路已成为众多用户首选的地址导航平台。我们持续追踪地址变更动态，第一时间更新导航信息，确保用户能够随时随地畅享社区内容。同时，我们还提供详细的访问教程、使用技巧和常见问题解答，帮助新老用户更好地使用草榴社区。
                  </p>
                  <p className="text-foreground-600 leading-relaxed mt-4">
                    我们的团队由一群热爱草榴社区的资深用户组成，深知用户在寻找可用地址过程中的困扰。因此，我们致力于打造一个可靠、及时、全面的导航服务平台。无论您是初次访问的新用户，还是经验丰富的老用户，草榴回家的路都能为您提供最贴心的导航服务。
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">用户口碑</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {[
                    {
                      name: '老用户张先生',
                      text: '用了草榴回家的路好几年了，每次地址失效都能在这里找到最新的。网站做得简洁好用，更新也很及时，强烈推荐给所有草榴用户！',
                      years: '使用3年',
                    },
                    {
                      name: '新用户小李',
                      text: '作为新用户一直找不到稳定入口，朋友推荐了这个导航站，问题立刻解决了。教程也很详细，让我快速上手了社区的各种功能。',
                      years: '使用6个月',
                    },
                    {
                      name: '资深会员老王',
                      text: '界面清爽无广告，地址更新速度快，分类清晰易查找。是我见过最用心的草榴导航站，已经推荐给身边所有朋友了。',
                      years: '使用2年',
                    },
                  ].map((review, i) => (
                    <div
                      key={i}
                      className="p-6 rounded-xl bg-background-100 border border-background-200/70"
                    >
                      <div className="flex items-center gap-1 text-accent-500 mb-3">
                        {[...Array(5)].map((_, j) => (
                          <i key={j} className="ri-star-fill text-sm" />
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                        &ldquo;{review.text}&rdquo;
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-foreground-900">
                          {review.name}
                        </span>
                        <span className="text-xs text-foreground-400">{review.years}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">联系我们</h2>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    如果您在使用过程中遇到任何问题，或有任何建议和反馈，欢迎通过以下方式联系我们。我们的团队会在24小时内回复您的消息。
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-lg text-primary-600" />
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">电子邮箱</p>
                        <p className="text-sm text-foreground-900">contact@caoliuhome.com</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-time-line text-lg text-accent-600" />
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">响应时间</p>
                        <p className="text-sm text-foreground-900">24小时内回复</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}